import { alpha, withStyles } from '@material-ui/core/styles';
import { Poppins, PoppinsMedium, PoppinsBold, PoppinsSemiBold, PoppinsExtraBold } from './typography'; // ----------------------------------------------------------------------

export var GlobalStyles = withStyles(function (theme) {
  return {
    '@global': {
      '@font-face': [Poppins, PoppinsMedium, PoppinsBold, PoppinsSemiBold, PoppinsExtraBold],
      html: {
        width: '100%',
        height: '100%',
        '-ms-text-size-adjust': '100%',
        '-webkit-overflow-scrolling': 'touch'
      },
      body: {
        width: '100%',
        height: '100%',
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
          width: 8,
          height: 6,
          backgroundColor: theme.palette.divider
        },
        '&::-webkit-scrollbar-thumb, & ::-webkit-scrollbar-thumb': {
          border: 'none',
          borderRadius: 8,
          backgroundColor: alpha(theme.palette.grey[600], 0.48)
        }
      },
      '#root': {
        width: '100%',
        height: '100%'
      },
      a: {
        color: theme.palette.primary.main,
        '&:hover': {
          color: theme.palette.primary.light,
          textDecoration: 'none'
        }
      },
      // Lazy Load Img
      '.blur-up': {
        WebkitFilter: 'blur(5px)',
        filter: 'blur(5px)',
        transition: 'filter 400ms, -webkit-filter 400ms'
      },
      '.blur-up.lazyloaded ': {
        WebkitFilter: 'blur(0)',
        filter: 'blur(0)'
      },
      '.MuiLoadingButton-pending.Mui-disabled ': {
        backgroundColor: theme.palette.primary.main
      }
    }
  };
})(function () {
  return null;
});